import React from 'react'
import { useSelector } from 'react-redux'
import { Grid, Typography } from '@material-ui/core'
import { userSelector } from '_/modules/authentication/selectors'

import useStyles from './styles'

export const TotalAnticipationValues = ({ totalMenuValues }) => {
  const styles = useStyles()
  const user = useSelector(userSelector)
  const showAntecipation = user?.activeProfile?.resourceAntecipation

  return (
    <Grid className={styles.totalValueContainer}>
      <Typography>
        <b>Total dos itens selecionados: </b>
      </Typography>
      <Typography>
        <b>Valor total </b>
        {totalMenuValues?.totalPriceServiceProvider}
      </Typography>
      {showAntecipation && (
        <Typography>
          <b>Taxa de antecipação </b>
          {totalMenuValues?.interestValue}
        </Typography>
      )}
      <Typography>
        <b>Valor líquido a receber </b>
        {totalMenuValues?.totalValue}
      </Typography>
    </Grid>
  )
}
